import {useMutation, useQueryClient} from '@tanstack/react-query'
import {httpDeclineAssignment, HttpDeclineAssignmentOptions} from '@features/assignment/http/assignment.http'
import {Assignment} from '@features/assignment/types.ts'
import {errorHandler} from '@utilities/helpers.ts'
import {captureException} from '@sentry/react'
import {parseAxiosPromise} from '@/axiosInstance.ts'
import {QUERY_KEYS} from '@/queryClient.ts'

export const useDeclineAssignment = (assignment: Assignment, options?: {onSuccess?: () => void}) => {
    const queryClient = useQueryClient()

    return useMutation<Assignment, unknown, HttpDeclineAssignmentOptions['payload']>({
        mutationFn: payload =>
            parseAxiosPromise({
                axiosPromise: httpDeclineAssignment({
                    payload,
                    urlParams: {assignmentId: assignment.id},
                    params: {response_type: 'extended'}
                }),
                responseShape: Assignment,
                onZodError: captureException
            }),
        onSuccess: () => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ASSIGNMENTS_REQUESTS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ASSIGNMENTS_COMPLETED]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ASSIGNMENTS_COUNT]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ASSIGNMENTS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.HOME_TABLE]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.REQUIRED_ACTIONS]})
            options?.onSuccess?.()
        },
        onError: errorHandler
    })
}
